// src/hooks/useInitializePhone.ts

import { useAppDispatch } from '../../hooks/useAppDispatch';
import { setPhoneVisible,  setPhone } from '../../store/reducers/phoneSlice';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import AircallWorkspace from 'aircall-everywhere'; // Replace with actual import if needed
import { setLogin } from '../../store/reducers/userSlice';
import {
    AIRCALL_USER_ID_SESSION_KEY,
    notifyAircallUserIdSessionChanged,
} from '../../utils/callsIdSessionSync';

// Custom hook for initializing the Aircall phone
const useInitializePhone = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState<string | null>(null);
  const [shouldFetchUser, setShouldFetchUser] = useState(false);

  const initializePhone = () => {
    const newPhone = new AircallWorkspace({
      domToLoadWorkspace: '#phone',
      onLogin: (settings: any) => {
        dispatch(setLogin(true));
        dispatch(setPhoneVisible(true));
        sessionStorage.setItem('isLogin', 'true');

        const userEmail = settings.user.email;
        const firstName = settings.user.first_name;
        sessionStorage.setItem('FirstName', firstName);
        const lastName = settings.user.last_name;
        sessionStorage.setItem('LastName', lastName);

        if (userEmail) {
          setEmail(userEmail); // Set the email
          setShouldFetchUser(true); // Trigger the API call
        } else {
          toast.error('Email is not available from Aircall settings.');
        }
      },
      onLogout: () => {
        dispatch(setLogin(false));
        dispatch(setPhoneVisible(false));
        sessionStorage.setItem('isLogin', 'false');
        sessionStorage.removeItem(AIRCALL_USER_ID_SESSION_KEY);
        notifyAircallUserIdSessionChanged();
        navigate('/');
        toast.info('You have been signed out. See you soon!', { toastId: 'logout' });
      },
    });

    dispatch(setPhone(newPhone));
  };

  return { initializePhone, email, shouldFetchUser, setEmail, setShouldFetchUser };
};

export default useInitializePhone;
